<script>
  import { afterUpdate, onDestroy } from "svelte";
  import SvgWrapper from "@/components/atoms/SvgWrapper.svelte";
  import SvgClose from "$assets/svg/close.svg?src";
  import { isBrowser } from "@/utils";
  export let show = false;
  export let handleClose;
  export let classes = "";
  export let height = "h-full";
  export let bgc = "bg-black";
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  const { bool, func, string, checkPropTypes } = PropTypes;
  const propTypes = {
    //  modal open or not
    show: bool,
    // function to handle close of modal
    handleClose: func,
    // css class
    classes: string,
    height: string,
    bgc: string,
  };
  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Modal");
  });

  afterUpdate(() => {
    if (show === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  });

  onDestroy(() => {
    if (isBrowser()) document.body.removeAttribute("style");
  });
</script>

<div
  class="bottom-0 left-0 fixed z-[1] w-full {height} {classes} {bgc} md:px-[7%] {show
    ? ''
    : 'hidden'}"
>
  <!-- Modal content -->
  {#if handleClose}
    <div class="flex justify-end p-md">
      <div class="cursor-pointer" on:click={handleClose}>
        <SvgWrapper
          className="h-lg w-lg text-primary-text-moj"
          svg={SvgClose}
        />
      </div>
    </div>
  {/if}
  <slot />
</div>
